import Columns from 'components/Columns';
import { Heading, P, Section, Wrapper } from 'components/base';
import PropTypes from 'prop-types';
import React from 'react';
import CheckIcon from 'svgs/icons/check-circle.svg';
import { bIcon, root } from './CheckIconColumn.module.scss';

const CheckIconColumn = ({ data, theme, padding, wrapper, columnCount }) => {
  const Item = ({ heading, description }) => {
    return (
      <div className={root}>
        <div className={bIcon}><CheckIcon /></div>
        <div>
          <Heading Tag="h3" bold size="SM" marginBottom="Xxs">
            {heading}
          </Heading>
          <P>{description}</P>
        </div>
      </div>
    );
  };
  Item.propTypes = {
    heading: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  };

  return (
    <Section padding={padding} theme={theme}>
      <Wrapper size={wrapper}>
        <Columns Item={Item} items={data} columnCount={columnCount} />
      </Wrapper>
    </Section>
  );
};

CheckIconColumn.propTypes = {
  data: PropTypes.array.isRequired,
  theme: PropTypes.string,
  wrapper: PropTypes.string,
  padding: PropTypes.string,
  columnCount: PropTypes.number,
};

CheckIconColumn.defaultProps = {
  padding: 'BottomL',
  theme: null,
  wrapper: 'ML',
  columnCount: 3,
};

export default CheckIconColumn;
